import React from 'react'
import Spinner from '../common/Spinner'

function InitialData({ loading, error, value }) {
    if (loading) return <div className='d-flex align-items-center justify-content-center'><Spinner /></div>
    if (error) return <p>{JSON.stringify(error)}</p>
    if (!value) return <div className='text-center font-weight-bold my-2'>Nothing to show</div>
    return <div>...</div>
}


export default InitialData